// extracted by mini-css-extract-plugin
export default {"action":"Notifications_action__GL+h9","contentWrapper":"Notifications_contentWrapper__ZJV8z","items":"Notifications_items__yazvU"};